(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/components/lobby-container.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/components/lobby-container.js');
"use strict";


const LobbyContainer = _ref => {
  let {
    children
  } = _ref;
  const {
    Background
  } = svs.eInstant.shared.components;
  return React.createElement(Background, {
    classNames: "tickets-einstant-lobby-container"
  }, children);
};
setGlobal('svs.eInstant.lobby.components.LobbyContainer', LobbyContainer);

 })(window);